import { render, staticRenderFns } from "./Sum.vue?vue&type=template&id=625343ee&"
import script from "./Sum.vue?vue&type=script&lang=js&"
export * from "./Sum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports